import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../../components/Form/Field'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'

import { formatOptionsList } from '../../../../../../../features/formatters'

import { IDENTITY, IDENTITY_ID } from '../../fields'
import { accessibleSocialPagesSelector } from '../../../../../../../modules/selectors/socialAccounts'

const stepFields = [IDENTITY]

function IdentityStep({ formik, handleStepChange }) {
  const { t } = useTranslation()

  // loaded in useAccessibleTikTokIdentities
  const accessibleSocialPages = useSelector(accessibleSocialPagesSelector)

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  const identityOptions = useMemo(
    options => {
      return formatOptionsList({
        list: accessibleSocialPages,
        labelName: 'name',
        valueName: 'external_id',
        imgName: 'thumbnail'
      })
    },
    [accessibleSocialPages]
  )

  return (
    <Step
      formTitle="Create an ad"
      stepTitle="Please select a TikTok identity to run the ad from"
      handleContinue={handleContinue}
    >
      <RadioBlock
        setFieldValue={() => {}}
        id="radio_tiktok_identity"
        name={IDENTITY_ID}
        value={IDENTITY_ID}
        selectedValue={IDENTITY_ID}
        label={t('Select TikTok identity')}
      >
        <Field
          formik={formik}
          name={IDENTITY}
          options={identityOptions}
          placeholder="TikTok Identity"
          autoComplete="off"
          // setFullOptionObject is added to be able to represent selected label when not in edit mode
          // also with this prop Select works the same way as MultiSelectBox
          setFullOptionObject={true}
        />
      </RadioBlock>
    </Step>
  )
}

export default IdentityStep
